import { ENDPOINTS } from "utils/endpoints";
import { GET_API_CALL, POST_API_CALL, PUT_API_CALL } from "utils/services";
import { APIResponseModal } from "utils/modals";
import { UPDATE_CARS_TYPE_REDUCER, UPDATE_DISCOUNTS_REDUCER } from "store/actionTypes";
import SHOW_TOAST from "utils/showToast";
import { removeEmptyValues } from "utils/constants";
import { mapCarTypeListItem, mapPaginatedResult } from "utils/apiMappers";

export const getCarTypesListing = (params: any = {}) => {
  return (dispatch: Function, getState: Function) => {
    const { page, limit, sortedBy, sortOrder } = getState().CarsTypeReducer;
    const { search = "" } = params;
    let parameters = "?";
    if (page) parameters += `page=${page}&`;
    if (limit) parameters += `limit=${limit}&`;
    if (sortedBy) parameters += `sortedBy=${sortedBy}&`;
    if (sortOrder) parameters += `sortOrder=${sortOrder}&`;
    if (search) parameters += `search=${search}&`;

    dispatch({
      type: UPDATE_CARS_TYPE_REDUCER,
      payload: { loader: true },
    });

    GET_API_CALL(
      ENDPOINTS.UTILITY.CARS_TYPE_LISTING,
      parameters === "?" ? "" : `${parameters.slice(0, -1)}`,
      (response: APIResponseModal) => {
        if (response.isSuccess) {
                    const dataToSend = mapPaginatedResult(
            response.data,
            mapCarTypeListItem
          );
                    dispatch({
            type: UPDATE_CARS_TYPE_REDUCER,
            payload: dataToSend,
          });
        }
        dispatch({
          type: UPDATE_CARS_TYPE_REDUCER,
          payload: { loader: false },
        });
      }
    );
  };
};
export const getAllCarTypes = (callback: Function = () => {}) => {
  return (dispatch: Function) => {
    const parameters = `?page=1&limit=100`;

    dispatch({
      type: UPDATE_CARS_TYPE_REDUCER,
      payload: { loader: true },
    });

    GET_API_CALL(
      ENDPOINTS.UTILITY.CARS_TYPE_LISTING,
      parameters,
      (response: APIResponseModal) => {
        if (response.isSuccess) {
          const dataToSend = mapPaginatedResult(
            response.data,
            mapCarTypeListItem
          );
          let rows = Array.isArray(dataToSend.result) ? dataToSend.result : [];
          if (!rows.length) {
            const raw = response.data;
            const list = Array.isArray(raw)
              ? raw
              : Array.isArray(raw?.data)
              ? raw.data
              : [];
            rows = list.map(mapCarTypeListItem);
          }
                    dispatch({
            type: UPDATE_CARS_TYPE_REDUCER,
            payload: {
              ...dataToSend,
              result: rows,
              allCarTypes: rows,
              loader: false,
            },
          });
          callback(rows);
        } else {
          dispatch({
            type: UPDATE_CARS_TYPE_REDUCER,
            payload: { loader: false },
          });
          callback([]);
        }
      }
    );
  };
};

export const getDiscountsList = () => {
  return (dispatch: Function, getState: Function) => {
    const { page, limit, sortedBy, sortOrder } = getState().CarsTypeReducer;

    let parameters = "?";
    if (page) parameters += `page=${page}&`;
    if (limit) parameters += `limit=${limit}&`;
    if (sortedBy) parameters += `sortedBy=${sortedBy}&`;
    if (sortOrder) parameters += `sortOrder=${sortOrder}&`;
    dispatch({
      type: UPDATE_DISCOUNTS_REDUCER,
      payload: { loader: true },
    });

    GET_API_CALL(
      ENDPOINTS.UTILITY.DISCOUNTS,
      parameters === "?" ? "" : `${parameters.slice(0, -1)}`,
      (response: APIResponseModal) => {
        if (response.isSuccess) {
          dispatch({
            type: UPDATE_DISCOUNTS_REDUCER,
            payload: { ...response.data, loader: false },
          });
        }
        dispatch({
          type: UPDATE_DISCOUNTS_REDUCER,
          payload: { loader: false },
        });
      }
    );
  };
};

export const createNewDiscount = (params: any) => {
  return (dispatch: Function, getState: Function) => {
    dispatch({
      type: UPDATE_DISCOUNTS_REDUCER,
      payload: { loader: true },
    });
    POST_API_CALL(
      ENDPOINTS.UTILITY.DISCOUNTS,
      params.data,
      (response: APIResponseModal) => {
        dispatch(getDiscountsList())
        params.callback(response)
      }
    );
  };
};


export const updateDiscount = (params: any) => {
  return (dispatch: Function, getState: Function) => {
    dispatch({
      type: UPDATE_DISCOUNTS_REDUCER,
      payload: { loader: true },
    });
    PUT_API_CALL(
      ENDPOINTS.UTILITY.DISCOUNTS,
      params.data,
      (response: APIResponseModal) => {
        dispatch(getDiscountsList())
        params.callback(response)
      }
    );
  };
};

export const AddCarType = (values: any, callback: Function) => {
  return (dispatch: Function, getState: Function) => {
    removeEmptyValues(values);
    dispatch({
      type: UPDATE_CARS_TYPE_REDUCER,
      payload: { loader: true },
    });
    POST_API_CALL(
      ENDPOINTS.UTILITY.ADD_CAR_TYPE,
      values,
      (response: APIResponseModal) => {
        if (response.isSuccess) {
          SHOW_TOAST(response?.data?.message, "success");
        }
        callback(response);
      }
    );
  };
};

const buildTypeListQuery = (params: Record<string, any>) => {
  const queryParams: string[] = [];
  Object.entries(params).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) {
      queryParams.push(`${key}=${encodeURIComponent(value)}`);
    }
  });
  return queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
};

const fetchTypeList = (
  endpoint: string,
  params: Record<string, any>,
  callback: Function = () => {}
) => {
  const query = buildTypeListQuery(params);
    GET_API_CALL(endpoint, query, (response: APIResponseModal) => {
    if (response.isSuccess) {
      const dataToSave = mapPaginatedResult(response.data);
            callback(dataToSave);
    } else {
      callback({ result: [] });
    }
  });
};

/** GET /api/v1/shinology/car/carType — used as categoryTypeId source when category=0 */
export const getAllCarTypesList = (
  params: any = {},
  callback: Function = () => {}
) => {
  return () => {
    fetchTypeList(
      ENDPOINTS.UTILITY.CARS_TYPE_LISTING,
      { page: params.page || 1, limit: params.limit || 100, search: params.search },
      callback
    );
  };
};

/** GET /api/v1/shinology/sofa/get-sofa-type?page&limit&seat */
export const getSofaType = (params: any = {}, callback: Function = () => {}) => {
  return () => {
    fetchTypeList(
      ENDPOINTS.UTILITY.SOFA_TYPE_LISTING,
      { page: params.page || 1, limit: params.limit || 100, seat: params.seat },
      callback
    );
  };
};

/** GET /api/v1/shinology/tank/get-tank-type?page&limit&search */
export const getTankType = (params: any = {}, callback: Function = () => {}) => {
  return () => {
    fetchTypeList(
      ENDPOINTS.UTILITY.TANK_TYPE_LISTING,
      { page: params.page || 1, limit: params.limit || 100, search: params.search },
      callback
    );
  };
};

/** GET /api/v1/shinology/carpet/get-carpet-type?page&limit&unit&size */
export const getCarpetType = (
  params: any = {},
  callback: Function = () => {}
) => {
  return () => {
    fetchTypeList(
      ENDPOINTS.UTILITY.CARPET_TYPE_LISTING,
      {
        page: params.page || 1,
        limit: params.limit || 100,
        unit: params.unit,
        size: params.size,
      },
      callback
    );
  };
};

